var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-icon"},[_c('img',{staticClass:"icon",attrs:{"id":_vm.icon_id,"src":require('../../../images/help.png')}}),_c('b-popover',{attrs:{"target":_vm.icon_id,"placement":"right","triggers":"hover focus"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }